import React, { useState } from "react"
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import moment from 'moment';
import AuthService from '../../../services/auth-service'
import notify from "devextreme/ui/notify";

// ***

function download(content, fileName, contentType) {
  var a = document.createElement("a");
  var file = new Blob([content], { type: contentType });
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
}

// ***

export default function ComputerListViewLicFormDialog(props) {
  const [licenseDiv64, setLicenseDiv64] = useState(null)  
  
  const notifySomething = (message, type = "success") => {
    notify({
      message: message,
      position: {
        my: 'center top',
        at: 'center top',
      },
    }, type, 3000);
  }  
  const handleClose = () => {
    props.onClickClose()
  }
  const handleLoadTxt = () => {
    setLicenseDiv64("LOADING...")    
    AuthService.getLicense(props.user_code).then(data => {
      if (data.is_valid) {
        var t0 = "---- BEGIN LICENSE DATA ----"
        var t1 = "---- END LICENSE DATA ----"
        var txt = () => (<div>{t0}<br />{data.value}<br />{t1}</div>)
        setLicenseDiv64(txt)
      } else {
        notifySomething(data.message, "error")
      }
    })
  }
  const handleDownloadDat = () => {
    AuthService.getLicense(props.user_code).then(data => {
      if (data.is_valid) {
        const b64toArray = (base64) => {
          var raw = window.atob(base64)
          var array = new Uint8Array(new ArrayBuffer(raw.length))
          var i
          for (i = 0; i < raw.length; i++)
            array[i] = raw.charCodeAt(i)
          return array.buffer;
        }
        //console.log(data.value)
        var dat_content = b64toArray(data.value)
        download(dat_content, 'license_' + props.user_code + '.dat', 'application/octet-stream');
      } else {
        notifySomething(data.message, "error")
      }
    })
  }
  
  var rows = props.lic_file.trim().split("\n")
  var num = 0
  //var date_2010 = (new Date('2010/01/01 00:00:00')).getTime() - ((new Date()).getTimezoneOffset() * 60000)
  var date_2010 = (new Date('2010/01/01 00:00:00')).getTime()
  var date_start = undefined
  var date_end = undefined
  var temp
  var comp = rows.map(row => {
    num++
    if (row.startsWith("DATA ATTIVAZIONE: ")) {
      temp = parseInt(row.replace("DATA ATTIVAZIONE: ", "")) * 1000
      temp += date_2010 
      //console.log(date_start)
      date_start = moment(temp)
      //console.log(date_start)
      date_start = date_start.format("DD/MM/YYYY HH:mm")
      //console.log(date_start)
    } else if (row.startsWith("DATA SCADENZA: ")) {
      temp = parseInt(row.replace("DATA SCADENZA: ", "")) * 1000
      temp += date_2010 
      //console.log(date_start)
      date_end = moment(temp)
      date_end = date_end.format("DD/MM/YYYY HH:mm")
      //console.log(date_end)
    }
    return (
      <div key={num}>
        {row}
      </div>        
    )
  })

  if (props.only_dates) {
    var lic_file = 
      "codice software: 2e32e564cb123121210\n" +
      "nome del programma: multipoint\n" +
      "user mode: basic\n" +
      "configuration: none\n" +
      "activation date: 3424350\n" +
      "end date: 56734434\n"
    rows = lic_file.trim().split("\n")
    num = 0
    comp = rows.map(row => {
      num++      
      return (
        <div key={num}>
          {row}
        </div>        
      )
    })
  }

  return (    
    <div>      
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle>VIEW LICENSE</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {licenseDiv64 != null ? (
              <Box sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 0, m: 0 }}>
                {licenseDiv64}
              </Box>
            ) : (
              <Box 
                sx={{ fontWeight: 'bold', fontFamily: 'Monospace', fontSize: 12, p: 0, m: 0 }} 
                className={props.only_dates ? 'blurred-text' : ''}
                style={props.only_dates ? { color: 'transparent', textShadow: '0 0 5px rgba(0,0,0,0.5)', userSelect: 'none' } : {}}
              >
                {comp}
              </Box>        
            )}
            {date_start && 
              <Box sx={{ fontWeight: 'bold', color: 'red', fontFamily: 'Monospace', fontSize: 18, p: 0, mt: 5 }}>
                License Start Date: {date_start}
              </Box>
            }
            {date_end && 
              <Box sx={{ fontWeight: 'bold', color: 'red', fontFamily: 'Monospace', fontSize: 18, p: 0, mt: 0 }}>
                License End Date: {'\u00A0'}{'\u00A0'}{date_end}
              </Box>
            }
          </DialogContentText>          
        </DialogContent>
        <DialogActions>
          {!licenseDiv64 && <Button onClick={handleLoadTxt}>Load Txt</Button>}
          <Button onClick={handleDownloadDat}>Download Dat</Button>
          <Button onClick={handleClose}>Close</Button>          
        </DialogActions>
      </Dialog>
    </div>
  );
}
